import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TagProductType } from '@design-system/components/organisms/tag-product/entities/tag-product.types';
import { TagBrandingType } from '@design-system/components/organisms/tag-product/entities/tag-branding.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-tag-product',
  templateUrl: './tag-product.component.html',
  styleUrls: ['./tag-product.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
  ]
})
export class TagProductDsComponent {

  @Input() type = TagProductType.Highlight;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() icon: Icon;
  @Input() branding: TagBrandingType;

  public readonly imageSize = ImageSize.None;
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;

  constructor() { }

  get useIcon(): boolean {
    return this.type !== TagProductType.Informative;
  }

  get useSubtitle(): boolean {
    return this.type === TagProductType.Informative && !!this.subtitle;
  }

  get tagIcon(): Icon {
    switch (this.type) {
      case TagProductType.ProBlack:
      case TagProductType.Pro:
        return Icon.Prime;
      case TagProductType.Rappi:
      case TagProductType.RappiCard:
      case TagProductType.Pay:
        return Icon.MustacheFlat;
      case TagProductType.Marriott:
        return Icon.MarriottBonvoyFlat;
      default:
        return this.icon;
    }
  }

  get fontColor(): TypographyColor {
    switch (this.type) {
      case TagProductType.Highlight:
      case TagProductType.ProBlack:
      case TagProductType.RappiCard:
        return TypographyColor.Invert;
      case TagProductType.Pro:
        return TypographyColor.PrimeBranding;
      case TagProductType.Purple:
        return null;
      default:
        return TypographyColor.Primary;
    }
  }

  get iconFillColor(): IconFillColor {
    switch (this.type) {
      case TagProductType.Highlight:
      case TagProductType.RappiCard:
        return IconFillColor.Light;
      case TagProductType.Rappi:
        return IconFillColor.Neon;
      case TagProductType.Pay:
        return IconFillColor.Primary;
      default:
        return null;
    }
  }

  get iconSize(): number {
    if (this.type === TagProductType.Marriott) {
      return 14;
    } else {
      return 16;
    }
  }

  get brandIcon(): Icon {
    switch (this.branding) {
      case TagBrandingType.Civitatis:
        return Icon.Civitatis;
      case TagBrandingType.Marriott:
        return Icon.MarriottBonvoy;
      default:
        return null;
    }
  }

  get brandIconSize(): number {
    switch (this.branding) {
      case TagBrandingType.Civitatis:
        return 50;
      case TagBrandingType.Marriott:
        return 70;
      default:
        return null;
    }
  }

  get brandIconColor(): IconFillColor {
    return this.branding === TagBrandingType.Civitatis ? IconFillColor.Light : IconFillColor.Primary;
  }

}
